/* eslint-disable global-require */
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import axios from 'axios';
import sanitizeHtml from 'sanitize-html';
import { BotsCreators } from '../../store/actions/bots';
import './index.scss';
import { dateToString, getTime } from '../../util/date';
import Carousel from '../../components/Carousel';
import Acessibilidade from './Acessibilidade/index';
import DocumentMessage from '../../components/DocumentMessage';
import SuggestionList from '../../components/SuggestionList';
import QuickAccess from '../../components/QuickAccess';
import ModalViewImages from '../../components/Chat/ModalViewImages';
import { WebsocketAdapter } from './WebsocketAdapter';

import audioOn from '../../assets/images/audio_on.svg';
import audioOff from '../../assets/images/audio_off.svg';

const audioReceivingAlert =
  'data:audio/mpeg;base64,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';
const audioSendingAlert =
  'data:audio/mpeg;base64,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';

const sendingAudio = new Audio(audioSendingAlert);
sendingAudio.volume = 0.7;

class MessageItem {
  constructor(id, type, message, from, suggestionList = []) {
    this.id = id;
    this.type = type;
    this.message = message;
    this.from = from;
    this.date = new Date();
    this.suggestionList = suggestionList;
  }
}

class ImageItem {
  constructor(id, type, image, from, fileTitle, fileDescription, title) {
    this.id = id;
    this.type = type;
    this.image = image;
    this.from = from;
    this.fileTitle = fileTitle;
    this.fileDescription = fileDescription;
    this.title = title;
    this.date = new Date();
  }
}

class DocumentItem {
  constructor(id, type, document, from) {
    this.id = id;
    this.type = type;
    this.document = document;
    this.from = from;
    this.date = new Date();
  }
}

class AudioItem {
  constructor(id, type, audio, from) {
    this.id = id;
    this.type = type;
    this.audio = audio;
    this.from = from;
    this.date = new Date();
  }
}

class VideoItem {
  constructor(id, type, video, from) {
    this.id = id;
    this.type = type;
    this.video = video;
    this.from = from;
    this.date = new Date();
  }
}

class CarouselItem {
  constructor(id, type, carousel, from) {
    this.id = id;
    this.type = type;
    this.carousel = carousel;
    this.from = from;
    this.date = new Date();
  }
}

let initiated = false;

const botIconDefault =
  'data:image/png;base64,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';

const Mousetrap = require('mousetrap');

const socketUrl = process.env.REACT_APP_SOCKET_URL || 'ws://localhost:3999';
const orchestratorUrl =
  process.env.REACT_APP_ORCHESTRATOR_URL || 'http://localhost:3334';
const getBotUrl =
  process.env.REACT_APP_LAMBDA_URL || 'http://localhost:3941/dev/getBotCdn';

class Webchat extends Component {
  socket = undefined;

  state = {
    message: '',
    messages: [],
    currentBotId: undefined,
    bot: undefined,
    botIcon: undefined,
    id: '',
    socketId: '',
    botId: '',
    focused: true,
    backgroundAccessibility: '',
    fontSizeAccessibility: 15,
    suggestionList: [],
    accessibilityOption: false,
    accessibilityNotReadMessagesList: [],
    quickAccess: {},
    isQuickAccessOpen: false,
    isQuickAccessActive: false,
    messageSelected: {},
    isNotificationSound: false,
    isMute: false,
    readMessages: [],
  };

  handleToggleModal = (message) => {
    this.setState({
      messageSelected:
        Object.values(this.state.messageSelected).length === 0 ? message : {},
    });
  };

  handleClickOutside = (event) => {
    const quickAccessButton = document.getElementById('quick-access-button');
    const quickAccessContainer = document.getElementById(
      'quick-access-container-list'
    );
    if (
      !quickAccessContainer?.contains(event.target) &&
      !quickAccessButton?.contains(event.target)
    ) {
      // eslint-disable-next-line react/destructuring-assignment
      this.handleCloseQuickAccess();
    }
  };

  onSubscribeResponse(data) {
    if (data && data.channels) {
      const channel = data.channels.find(
        (i) => i.channelId.toLowerCase() === 'webchat'
      );

      this.setState({
        isNotificationSound: channel ? channel.isNotificationSound : false,
      });

      if (channel && channel.settings && channel.settings.botFab) {
        this.setState({
          botIcon: channel.settings.botFab,
          bot: data,
          quickAccess: data.quickAccess || {},
          isQuickAccessActive:
            (data.quickAccess && data.quickAccess.quickAccessActive) || false,
        });
      } else {
        this.setState({ botIcon: botIconDefault, id: data.id });
      }
    }
  }

  execSocket() {
    if (!this.socket) {
      this.socket = new WebsocketAdapter(socketUrl);

      this.socket.connect();
      this.socket.onOpen(async () => {
        const { id } = this.state;

        if (!id) {
          if (!initiated) {
            const messages = [...this.state.messages];
            if (messages.length === 0) {
              messages.push(new MessageItem('MESSAGE_INIT'));
            }

            this.setState({
              messages,
              message: '',
            });
          }
        }
        this.socket.sendMessage({
          action: 'link',
          data: { sessionId: id, botId: this.botId },
        });
      });
      this.socket.onLink(async ({ data }) => {
        const newSocketId = data.socketId;
        const { id } = this.state;

        if (!initiated) {
          initiated = true;
          const response = await axios.post(
            `${orchestratorUrl}/webchat/subscribe`,
            {
              sessionId: id || '',
              botId: this.botId,
              socketId: newSocketId,
              isPreview: false,
              channel: 'webchat',
            }
          );
          this.setState({ id: response.data.sessionId });
        }
        this.setState({ socketId: newSocketId });
      });
      this.socket.onMessage((data) => {
        const messages = [...this.state.messages].filter(
          (i) => i.type !== 'TYPING'
        );
        const accessibilityNotReadMessages = [
          ...this.state.accessibilityNotReadMessagesList,
        ];

        if (data.type !== 'TYPING') {
          if (this.state.isNotificationSound) {
            receivingAudio.muted = this.state.isMute;
            receivingAudio.play();
          }

          if (this.state.focused) {
            axios.post(`${orchestratorUrl}/webchat/status`, {
              sessionId: this.state.id,
              botId: this.botId,
              status: 'read',
              messageId: data.id,
            });
            const newReadMessages = [...this.state.readMessages, data.id];
            this.setState({ readMessages: newReadMessages });
          } else {
            axios.post(`${orchestratorUrl}/webchat/status`, {
              sessionId: this.state.id,
              botId: this.botId,
              status: 'delivered',
              messageId: data.id,
            });
          }
        }

        if (data && data.type !== 'TYPING' && this.state.accessibilityOption) {
          document.getElementById('accessibility-first-item-list').focus();
        }

        messages.push(this.handleMountMessage(data));

        if (data && data.type !== 'TYPING') {
          accessibilityNotReadMessages.push(this.handleMountMessage(data));
        }

        this.setState({ messages });
        this.setState({
          accessibilityNotReadMessagesList: accessibilityNotReadMessages,
        });
        this.autoScroll();
      });
      this.socket.onEndConversation(({ data }) => {
        if (!data.isTransfer) {
          this.setState({
            currentBotId: this.botId,
            id: '',
          });
        }
      });

      const receivingAudio = new Audio(audioReceivingAlert);
      receivingAudio.volume = 0.7;
      receivingAudio.preload = true;

      document.addEventListener('mousedown', (event) =>
        this.handleClickOutside(event)
      );
    }
  }

  componentDidMount() {
    const { currentBotId } = this.state;
    const {
      match: {
        params: { botid },
      },
    } = this.props;

    this.botId = currentBotId || botid;
    this.execSocket();
    const getBotData = async () => {
      const response = await axios.get(`${getBotUrl}/${this.botId}`);
      this.onSubscribeResponse(response.data);
    };

    getBotData();
    this.nameInput.focus();

    if (!currentBotId) {
      this.setState({ currentBotId: botid });
    }

    Mousetrap.bind('ctrl+shift+3', () =>
      this.handleToggleAccessibilityOptions()
    );
    document.getElementById('accessibility-notification-message').focus();
  }

  componentWillUnmount() {
    Mousetrap.unbind('ctrl+shift+3');
  }

  handleMountMessage = (data) => {
    if (data.type === 'TYPING' || data.hasOwnProperty('message')) {
      return new MessageItem(
        data.id,
        data.type,
        sanitizeHtml(data.message),
        'BOT',
        data.suggestionList
      );
    }
    if (data.type === 'IMAGE' && data.image) {
      return new ImageItem(
        data.id,
        data.type,
        data.image,
        'BOT',
        data.fileTitle,
        data.fileDescription,
        data.title
      );
    }
    if (data.type === 'DOCUMENT' && data.document.fileUrl) {
      return new DocumentItem(data.id, data.type, data.document, 'BOT');
    }
    if (data.type === 'AUDIO' && data.audio.fileUrl) {
      return new AudioItem(data.id, data.type, data.audio, 'BOT');
    }
    if (data.type === 'VIDEO' && data.video.fileUrl) {
      return new VideoItem(data.id, data.type, data.video, 'BOT');
    }
    if (data.type === 'CAROUSEL' && data.carousel) {
      return new CarouselItem(data.id, data.type, data.carousel, 'BOT');
    }
    return false;
  };

  handleToggleAccessibilityOptions = () => {
    this.setState({ accessibilityOption: !this.state.accessibilityOption });
    if (this.state.accessibilityOption) {
      document.getElementById('accessibility-first-item-list').focus();
    }
    document.addEventListener('mousedown', (event) =>
      this.handleClickOutside(event)
    );
  };

  sendMessage = async (message, type, ext, properties = {}) => {
    const { currentBotId } = this.state;
    const {
      match: {
        params: { botid },
      },
    } = this.props;
    if (!currentBotId) {
      this.setState({ currentBotId: botid });
    }

    const { messages, id, socketId, isNotificationSound, isMute } = this.state;

    if (message && message.trim().length > 0) {
      if (type === 'TEXT') {
        messages.push({ from: 'USER', message, type });
      } else if (type === 'IMAGE') {
        messages.push({ from: 'USER', image: message, type });
      } else if (type === 'DOCUMENT') {
        messages.push({
          from: 'USER',
          message,
          properties,
          type,
        });
      } else if (type === 'AUDIO') {
        messages.push({ from: 'USER', audio: { fileUrl: message }, type });
      } else if (type === 'VIDEO') {
        messages.push({ from: 'USER', video: { fileUrl: message }, type });
      } else {
        messages.push({ from: 'USER', message, type });
      }

      if (isNotificationSound) {
        sendingAudio.muted = isMute;
        sendingAudio.play();
      }
    }

    this.handleAccessibilityReadMessage();
    this.setState({ messages });
    this.autoScroll();

    if (!id) {
      const response = await axios.post(
        `${orchestratorUrl}/webchat/subscribe`,
        {
          sessionId: id || '',
          botId: this.botId,
          socketId,
          isPreview: false,
          channel: 'webchat',
        }
      );

      this.setState({ id: response.data.sessionId });
      return;
    }

    const { data } = await axios.post(`${orchestratorUrl}/webchat/message`, {
      botId: this.botId,
      message,
      isMedia: ext !== '',
      ext,
      sessionId: id,
      botChannel: 'webchat',
      isPreview: false,
      socketId,
    });

    if (data && data?.isNewSession) {
      const newSessionId = data.sessionId;
      this.setState({ id: newSessionId });
    }
  };

  autoScroll = () => {
    setTimeout(() => {
      const e = document.getElementById('webchat-body-chat-messages');
      if (e) {
        e.scrollTop = e.scrollHeight;
      }
    }, 200);
  };

  handleInputChange(event) {
    const message = event.target.value;
    this.setState({ message });
  }

  handleSubmit = (event) => {
    event.preventDefault();

    const { message } = this.state;

    this.setState({ message: '' });

    this.sendMessage(message, 'TEXT', '');
  };

  handleCarouselButtonClick = (clickInfo) => {
    const { clickedButton, clickedCard } = clickInfo;
    const { destination } = clickedButton;
    const { type, value } = destination;

    if (type === 'url') {
      window.open(value, '_blank');
    }

    if (type === 'phone') {
      window.open(`tel:${value}`, '_blank');
    }

    const { currentBotId } = this.state;
    const { botid } = this.props.match.params;
    if (!currentBotId) {
      this.setState({ currentBotId: botid });
    }
    axios.post(`${orchestratorUrl}/webchat/action`, {
      botId: this.botId,
      action: { type: 'CAROUSEL', data: { clickedButton, clickedCard } },
      sessionId: this.state.id,
    });
  };

  onSelectFile = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const extSplit = e.target.files[0].name.split('.');
      const file = e.target.files[0];
      const ext = extSplit[extSplit.length - 1].toLowerCase();
      document.getElementById('profile_pic').value = null;
      const reader = new FileReader();
      reader.readAsDataURL(file);
      const properties = {
        name: file.name,
        ext,
        size: file.size,
      };
      if (
        ext === 'jpeg' ||
        ext === 'png' ||
        ext === 'jpg' ||
        ext === 'gif' ||
        ext === 'bmp'
      ) {
        reader.addEventListener(
          'load',
          () => this.sendMessage(reader.result, 'IMAGE', ext),
          false
        );
      } else if (
        ext === 'mp3' ||
        ext === 'wav' ||
        ext === 'ogg' ||
        ext === 'oga' ||
        ext === 'mpga'
      ) {
        reader.addEventListener(
          'load',
          () => this.sendMessage(reader.result, 'AUDIO', ext),
          false
        );
      } else if (ext === 'mp4' || ext === 'm4v') {
        reader.addEventListener(
          'load',
          () => this.sendMessage(reader.result, 'VIDEO', ext),
          false
        );
      } else if (
        ext === 'doc' ||
        ext === 'docx' ||
        ext === 'txt' ||
        ext === 'csv' ||
        ext === 'pdf' ||
        ext === 'xls' ||
        ext === 'xlsx' ||
        ext === 'ppt' ||
        ext === 'pptx'
      ) {
        reader.addEventListener(
          'load',
          () => {
            this.sendMessage(reader.result, 'DOCUMENT', ext, properties);
          },
          false
        );
      } else if (
        ext === 'zip' ||
        ext === 'rar' ||
        ext === 'gz' ||
        ext === '7z'
      ) {
        reader.addEventListener(
          'load',
          () => {
            this.sendMessage(reader.result, 'DOCUMENT', ext, properties);
          },
          false
        );
      }
    }
  };

  treatMessage = (message) => {
    const linkRegex =
      /((http:\/\/|https:\/\/|ftp:\/\/)|(www.))+([\w_-]+(?:(?:\.[\w_-]+)+))([\w.,@?^=%&:/~+#-]*[\w@?^=%&/~+#-])?/gi;
    const strongRegex = /\*(.*?)\*/g;
    const breaklineRegex = /\n/g;

    let messageTreated = message.replace(linkRegex, function (str) {
      if (!str.match(/http/)) {
        return `<a target="_blank" href="http://${str}">${str}</a>`;
      }
      return `<a target="_blank" href="${str}">${str}</a>`;
    });

    messageTreated = messageTreated.replace(strongRegex, function (str) {
      return `<strong>${str.substr(1, str.length - 2)}</strong>`;
    });

    messageTreated = messageTreated.replace(breaklineRegex, '<br/>');

    let validationMessageHTML = false;

    const validatedTag = ['<html', '<script', '<style', '<table'];

    validationMessageHTML = validatedTag.some((tag) =>
      messageTreated.includes(tag)
    );

    let createReturnHTML = '';

    if (messageTreated.includes('<finaltag />')) {
      createReturnHTML = `<xmp style="white-space: break-spaces;">${
        messageTreated.split('<finaltag />')[0]
      }</xmp>`;

      createReturnHTML += messageTreated.split('<finaltag />')[1];
    }

    return validationMessageHTML ? createReturnHTML : messageTreated;
  };

  setFontSizeAccess = (value) => {
    this.setState({
      fontSizeAccessibility: value,
    });
  };

  handleAccessibilityReadMessage = () => {
    this.setState({ accessibilityNotReadMessagesList: [] });
  };

  handleAccessibilityList = (list) => {
    const listLength = list.length;

    if (listLength > 0) {
      let accessibilityList = [...list];
      if (listLength > 10) {
        accessibilityList = accessibilityList.slice(listLength - 9, listLength);
      }

      const returnedList = accessibilityList.map((message, index) => {
        const divId = message.from === 'BOT' ? 'botMessage' : 'userMessage';
        if (message.type === 'MESSAGE') {
          return (
            <li key={`${index}-message`} className="accessibility-item">
              {message.from === 'BOT' ? (
                <span>Mensagem do Bote</span>
              ) : (
                <span>Mesagem do Usuário</span>
              )}
              <div id={divId}>
                <p
                  dangerouslySetInnerHTML={{
                    __html: this.treatMessage(message.message),
                  }}
                />
              </div>
            </li>
          );
        }
        if (message.type === 'TEXT') {
          return (
            <li key={`${index}-message`} className="accessibility-item">
              {message.from === 'BOT' ? (
                <span>Mensagem do Bote</span>
              ) : (
                <span>Mesagem do Usuário</span>
              )}
              <div id={divId}>
                <p>{message.message}</p>
              </div>
            </li>
          );
        }
        if (message.type === 'TYPING') {
          return (
            // eslint-disable-next-line react/no-array-index-key
            <li key={`${index}-message`} className="accessibility-item">
              <div>
                <p>&bull;&bull;&bull;</p>
              </div>
            </li>
          );
        }
        if (message.type === 'IMAGE') {
          return (
            // eslint-disable-next-line react/no-array-index-key
            <li key={`${index}-message`} className="accessibility-item">
              {message.from === 'BOT' ? (
                <span>Mensagem do Bote</span>
              ) : (
                <span>Mesagem do Usuário</span>
              )}
              <div id={divId}>
                <span className="accessibility-item">{message.title}</span>
                <p>
                  <img
                    srcSet={message.image}
                    alt={message.title}
                    title={message.fileTitle}
                  />
                </p>
              </div>
            </li>
          );
        }
        if (message.type === 'DOCUMENT') {
          const channel = (this.state.bot?.channels || []).find(
            (i) => i.channelId.toLowerCase() === 'webchat'
          );
          const mainColor = channel?.settings
            ? channel?.settings?.mainColor || '#FFAA00'
            : '#FFAA00';
          const secondaryColor = channel?.settings
            ? channel?.settings?.secondaryColor || '#D6DAE0'
            : '#D6DAE0';

          return (
            // eslint-disable-next-line react/no-array-index-key
            <li key={`${index}-message`} className="accessibility-item">
              <span>
                {`Documento para Download - Título ${message.document.title}`}
              </span>
              <DocumentMessage
                divId={divId}
                message={message}
                mainColor={mainColor}
                secondaryColor={secondaryColor}
              />
            </li>
          );
        }
        if (message.type === 'AUDIO') {
          return (
            // eslint-disable-next-line react/no-array-index-key
            <li key={`${index}-message`} className="accessibility-item">
              {message.from === 'BOT' ? (
                <span>Mensagem do Bote</span>
              ) : (
                <span>Mesagem do Usuário</span>
              )}
              <div>
                <span>
                  {message.audio.title}
                  {'Para reproduzir digitar espaço no botão reproduzir'}
                </span>
                <audio preload="auto" controls>
                  <source src={message.audio.fileUrl} type="audio/mp3" />
                </audio>
              </div>
            </li>
          );
        }
        if (message.type === 'VIDEO') {
          return (
            // eslint-disable-next-line react/no-array-index-key
            <li key={`${index}-message`} className="accessibility-item">
              {message.from === 'BOT' ? (
                <span>Mensagem do Bote</span>
              ) : (
                <span>Mesagem do Usuário</span>
              )}
              <span />
              <div>
                <span>
                  {message.video.title}
                  {'Para reproduzir digitar espaço no botão reproduzir'}
                </span>
                <div>
                  <video preload="auto" controls>
                    <source src={message.video.fileUrl} type="video/mp4" />
                  </video>
                </div>
              </div>
            </li>
          );
        }
        if (message.type === 'CAROUSEL') {
          return (
            <li key={`${index}-message`} className="accessibility-item">
              <div>
                <Carousel
                  carouselData={message.carousel}
                  onButtonClick={this.handleCarouselButtonClick}
                  onImageClick={this.handleToggleModal}
                />
              </div>
            </li>
          );
        }
      });

      return returnedList;
    }
    return <span>Não há novas mensagens.</span>;
  };

  handleQuickAccessClick = () => {
    const listRule = {
      manual: 'manualList',
      lastday: 'lasdayList',
      lastweek: 'lastweekList',
      lastmonth: 'lastmonthList',
    };

    const { quickAccess } = this.state;

    if (quickAccess && quickAccess.quickAccessActive) {
      const rule = quickAccess.sortingRules;
      const theRule = listRule[rule];
      if (
        rule !== '' &&
        quickAccess[theRule] &&
        quickAccess[theRule].length > 0
      ) {
        // eslint-disable-next-line react/destructuring-assignment
        // eslint-disable-next-line react/no-access-state-in-setstate
        this.setState({ isQuickAccessOpen: !this.state.isQuickAccessOpen });
      }
    }
  };

  handleCloseQuickAccess = () => {
    const listRule = {
      manual: 'manualList',
      lastday: 'lasdayList',
      lastweek: 'lastweekList',
      lastmonth: 'lastmonthList',
    };

    const { quickAccess } = this.state;

    if (quickAccess && quickAccess.quickAccessActive) {
      const rule = quickAccess.sortingRules;
      const theRule = listRule[rule];
      if (
        rule !== '' &&
        quickAccess[theRule] &&
        quickAccess[theRule].length > 0
      ) {
        // eslint-disable-next-line react/destructuring-assignment
        // eslint-disable-next-line react/no-access-state-in-setstate
        this.setState({ isQuickAccessOpen: false });
      }
    }
  };

  handleSendQuickAccessItemId = (props) => {
    const { itemId, title } = props;
    const { currentBotId } = this.state;
    const {
      match: {
        params: { botid },
      },
    } = this.props;
    if (!currentBotId) {
      this.setState({ currentBotId: botid });
    }
    const { id } = this.state;
    axios.post(`${orchestratorUrl}/webchat/quick-access`, {
      sessionId: id,
      botId: this.botId,
      itemId,
      name: title,
      isPreview: false,
    });
  };

  render() {
    const { i18n } = this.props;
    const {
      message,
      messages,
      botIcon,
      bot,
      fontSizeAccessibility,
      accessibilityNotReadMessagesList,
    } = this.state;

    let suggestionListOpen = false;
    let suggestions = [];
    const channel = (bot?.channels || []).find(
      (i) => i.channelId.toLowerCase() === 'webchat'
    );
    const mainColor = channel?.settings
      ? channel?.settings?.mainColor || '#FFAA00'
      : '#FFAA00';
    const secondaryColor = channel?.settings
      ? channel?.settings?.secondaryColor || '#D6DAE0'
      : '#D6DAE0';
    const mainTextColor = channel?.settings
      ? channel?.settings?.mainTextColor || '#fff'
      : '#FFAA00';
    const secondaryTextColor = channel?.settings
      ? channel?.settings?.secondaryTextColor || '#fff'
      : '#D6DAE0';
    const headerTextColor = channel?.settings
      ? channel?.settings?.mainTextColor || '#fff'
      : '#fff';
    const headerName = channel?.settings
      ? channel?.settings?.headerName || 'Webchat'
      : 'Webchat';
    const poweredBy = channel?.settings ? channel?.poweredBy : '';
    const poweredByUrl = channel?.settings ? channel?.poweredByUrl : '';

    return (
      <>
        <div
          className="webchat-container"
          onFocus={() => {
            if (!this.state.focused) {
              this.setState({ focused: true });
              messages.forEach((m) => {
                if (
                  m.from === 'BOT' &&
                  m.id &&
                  this.state.id &&
                  !this.state.readMessages.includes(m.id)
                ) {
                  axios.post(`${orchestratorUrl}/webchat/status`, {
                    sessionId: this.state.id,
                    botId: this.botId,
                    status: 'read',
                    messageId: m.id,
                  });
                  const newReadMessages = [...this.state.readMessages, m.id];
                  this.setState({ readMessages: newReadMessages });
                }
              });
            }
          }}
          onBlur={() => this.setState({ focused: false })}
        >
          <header
            className="webchat-header d-flex justify-content-center"
            style={{ backgroundColor: mainColor }}
          >
            <div className="container-webchat-header">
              <img
                src={botIcon}
                alt={i18n.t('Ícone do Bote')}
                width={50}
                height={50}
              />
              <h1
                id="accessibility-notification-message"
                className="accessibility-item"
                ref={(input) => {
                  this.nameInput = input;
                }}
              >
                Para {this.state.accessibilityOption ? 'desativar' : 'ativar'}{' '}
                configuração de acessibilidade digite simultaneamente Control
                Shift três
              </h1>
              <h2
                className="webchat-header-name"
                style={{
                  fontSize: fontSizeAccessibility,
                  color: headerTextColor,
                }}
              >
                {headerName}
              </h2>
            </div>
            {/* add botão mudo */}
            {this.state.isNotificationSound && (
              <button
                type="button"
                onClick={() => this.setState({ isMute: !this.state.isMute })}
                title={this.state.isMute ? 'Mudo' : 'Notificação ativa'}
                style={{
                  background: 'transparent',
                  border: 0,
                  paddingRight: 16,
                  paddingLeft: 16,
                }}
              >
                <img
                  src={this.state.isMute ? audioOff : audioOn}
                  alt={this.state.isMute ? 'Mudo' : 'Notificação ativa'}
                  style={{
                    width: 23,
                  }}
                />
              </button>
            )}
            <Acessibilidade
              setFontSizeAccess={this.setFontSizeAccess}
              fontSizeAccessibility={fontSizeAccessibility}
            />
          </header>
          <div className="webchat-body d-flex justify-content-center">
            <div style={{ width: '100%' }}>
              <div className="webchat-body-chat">
                <main
                  id="webchat-body-chat-messages"
                  className={
                    messages[messages.length - 1]?.suggestionList &&
                    messages[messages.length - 1]?.suggestionList.length > 0
                      ? 'webchat-body-chat-messages with-suggestion'
                      : 'webchat-body-chat-messages'
                  }
                  title="Lista de Mensagens"
                >
                  <ul>
                    {messages.map((message, index) => {
                      suggestionListOpen = false;
                      suggestions = [];
                      const className =
                        message.from === 'BOT'
                          ? 'webchat-body-chat-messages-bot mb-3'
                          : 'webchat-body-chat-messages-user mb-3';
                      const divId =
                        message.from === 'BOT' ? 'botMessage' : 'userMessage';
                      const color =
                        message.from === 'BOT' ? secondaryColor : mainColor;
                      const colorText =
                        message.from === 'BOT'
                          ? secondaryTextColor
                          : mainTextColor;
                      if (message.type === 'MESSAGE_INIT') {
                        return (
                          <li key={`${index}-message`}>
                            <div className="col-md-12 d-flex justify-content-center align-items-center mb-4">
                              <div className="webchat-body-chat-messages-date-line" />
                              <h4
                                className="webchat-body-chat-messages-date"
                                style={{ fontSize: fontSizeAccessibility }}
                              >
                                {i18n.t('Chat iniciado em ')}{' '}
                                {dateToString(message.date, 'dd/MM/yyyy')}{' '}
                                {i18n.t('às')} {getTime(message.date)}
                              </h4>
                              <div className="webchat-body-chat-messages-date-line" />
                            </div>
                          </li>
                        );
                      }
                      if (message.type === 'MESSAGE') {
                        if (
                          message.suggestionList &&
                          message.suggestionList.length > 0
                        ) {
                          suggestionListOpen = true;
                          suggestions = message.suggestionList;
                        }
                        return (
                          // eslint-disable-next-line react/no-array-index-key
                          <li key={`${index}-message`} className={className}>
                            {message.from === 'BOT' ? (
                              <img
                                src={botIcon}
                                alt={i18n.t('Mensagem do Bote')}
                              />
                            ) : (
                              <img
                                src={botIcon}
                                alt={i18n.t('Mensagem do Usuário')}
                              />
                            )}
                            <div
                              id={divId}
                              style={{ maxWidth: '100%', paddingRight: '55px' }}
                            >
                              <p
                                style={{
                                  background: color,
                                  overflowWrap: 'break-word',
                                  fontSize: fontSizeAccessibility,
                                  color: colorText,
                                  lineHeight: 1,
                                }}
                                dangerouslySetInnerHTML={{
                                  __html: this.treatMessage(message.message),
                                }}
                              />
                              <span>{getTime(message.date)}</span>
                            </div>
                          </li>
                        );
                      }
                      if (message.type === 'TEXT') {
                        return (
                          // eslint-disable-next-line react/no-array-index-key
                          <li key={`${index}-message`} className={className}>
                            {message.from === 'BOT' ? (
                              <img
                                src={botIcon}
                                alt={i18n.t('Mensagem do Bote')}
                              />
                            ) : (
                              <img
                                src="//:0"
                                alt={i18n.t('Mensagem do Usuário')}
                                className="accessibility-item"
                              />
                            )}
                            <div id={divId}>
                              <p
                                style={{
                                  background: color,
                                  fontSize: fontSizeAccessibility,
                                  color: colorText,
                                  lineHeight: 1,
                                }}
                              >
                                {message.message}
                              </p>
                              <span>{getTime(message.date)}</span>
                            </div>
                          </li>
                        );
                      }
                      if (message.type === 'TYPING') {
                        return (
                          // eslint-disable-next-line react/no-array-index-key
                          <li key={`${index}-message`} className={className}>
                            <div className="webchat-body-chat-messages-bot-typing">
                              <p
                                style={{ background: color, color: colorText }}
                              >
                                &bull;&bull;&bull;
                              </p>
                            </div>
                          </li>
                        );
                      }
                      if (message.type === 'IMAGE') {
                        return (
                          // eslint-disable-next-line react/no-array-index-key
                          <li key={`${index}-message`} className={className}>
                            {message.from === 'BOT' ? (
                              <img
                                src={botIcon}
                                alt={i18n.t('Mensagem do Bote')}
                              />
                            ) : (
                              <img
                                src="//:0"
                                alt={i18n.t('Mensagem do Usuário')}
                                className="accessibility-item"
                              />
                            )}
                            <div
                              id={divId}
                              style={{
                                display: 'flex',
                                flexDirection: 'column',
                              }}
                            >
                              <span className="accessibility-item">
                                {message.title}
                              </span>
                              <p
                                className="container-document-webchat"
                                style={{ background: color }}
                              >
                                <img
                                  srcSet={message.image}
                                  className={`img-fluid ${
                                    message.from === 'BOT'
                                      ? 'img-preview-image'
                                      : 'img-preview-image-client'
                                  }`}
                                  alt={message?.fileDescription || ''}
                                  title={message.fileTitle}
                                  onClick={() =>
                                    this.handleToggleModal(message)
                                  }
                                  style={{ cursor: 'pointer' }}
                                />
                              </p>
                              <span>{getTime(message.date)}</span>
                            </div>
                          </li>
                        );
                      }
                      if (message.type === 'DOCUMENT') {
                        return (
                          <li key={`${index}-message`} className={className}>
                            {message.from === 'BOT' ? (
                              <img
                                src={botIcon}
                                alt={i18n.t('Mensagem do Bote')}
                              />
                            ) : (
                              <img
                                src="//:0"
                                alt={i18n.t('Mensagem do Usuário')}
                                className="accessibility-item"
                              />
                            )}
                            <span className="accessibility-item">
                              {`Documento para Download - Título ${message.properties?.name}`}
                            </span>
                            <DocumentMessage
                              divId={divId}
                              message={message}
                              mainColor={mainColor}
                              secon
                              daryColor={secondaryColor}
                            />
                          </li>
                        );
                      }
                      if (message.type === 'AUDIO') {
                        return (
                          // eslint-disable-next-line react/no-array-index-key
                          <li key={`${index}-message`} className={className}>
                            {message.from === 'BOT' ? (
                              <img
                                src={botIcon}
                                alt={i18n.t('Mensagem do Bote')}
                              />
                            ) : (
                              <img
                                src="//:0"
                                alt={i18n.t('Mensagem do Usuário')}
                                className="accessibility-item"
                              />
                            )}
                            <span className="accessibility-item">
                              {message.audio.title}
                            </span>
                            <div
                              id={divId}
                              style={{
                                display: 'flex',
                                flexDirection: 'column',
                              }}
                            >
                              <audio
                                preload="auto"
                                controls
                                className="preview-audio container-document-webchat"
                                style={{ background: color }}
                                title={message.audio.title}
                              >
                                <track kind="captions" />
                                <source
                                  src={message.audio.fileUrl}
                                  type="audio/mp3"
                                />
                              </audio>
                              <span>{getTime(message.date)}</span>
                            </div>
                          </li>
                        );
                      }
                      if (message.type === 'VIDEO') {
                        return (
                          <li key={`${index}-message`} className={className}>
                            {message.from === 'BOT' ? (
                              <img
                                src={botIcon}
                                alt={i18n.t('Mensagem do Bote')}
                              />
                            ) : (
                              <img
                                src="//:0"
                                alt={i18n.t('Mensagem do Usuário')}
                                className="accessibility-item"
                              />
                            )}
                            <div
                              id={divId}
                              style={{
                                display: 'flex',
                                flexDirection: 'column',
                              }}
                            >
                              <span className="accessibility-item">
                                {message.video.title}
                              </span>
                              <div>
                                <video
                                  controls
                                  className={
                                    message.from === 'BOT'
                                      ? 'img-preview-video'
                                      : 'img-preview-video-client'
                                  }
                                  style={{
                                    background: color,
                                  }}
                                  title={message.video.title}
                                >
                                  <track kind="captions" />
                                  <source
                                    src={message.video.fileUrl}
                                    type="video/mp4"
                                  />
                                </video>
                              </div>
                              <span>{getTime(message.date)}</span>
                            </div>
                          </li>
                        );
                      }

                      if (message.type === 'CAROUSEL') {
                        return (
                          <li
                            key={`${index}-message`}
                            className={className}
                            style={{ marginBottom: '36px' }}
                          >
                            {message.from === 'BOT' ? (
                              <img
                                src={botIcon}
                                alt={i18n.t('Mensagem do Bote')}
                              />
                            ) : (
                              <img
                                src="//:0"
                                alt={i18n.t('Mensagem do Usuário')}
                                className="accessibility-item"
                              />
                            )}
                            <div
                              id={divId}
                              style={{ width: '240px', position: 'relative' }}
                            >
                              <Carousel
                                carouselData={message.carousel}
                                onButtonClick={this.handleCarouselButtonClick}
                                onImageClick={this.handleToggleModal}
                              />
                            </div>
                          </li>
                        );
                      }
                    })}
                    <li tabIndex="4" className="accessibility-item">
                      Seta para cima acessa últimas mensagens da lista
                    </li>
                  </ul>
                </main>
                <section
                  className="accessibility-item"
                  title="Lista de Contexto"
                >
                  {this.state.accessibilityOption ? (
                    <ul id="accessibility-list" className="accessibility-item">
                      <li tabIndex="5" className="accessibility-item">
                        <h3>Para ler lista de contexto seta para baixo</h3>
                      </li>
                      {this.handleAccessibilityList(messages)}
                      <li className="accessibility-item">
                        Fim da lista. Para acessar mais mensagens acessar lista
                        principal.
                      </li>
                    </ul>
                  ) : (
                    ''
                  )}
                </section>
                <section
                  className="accessibility-item"
                  title="Lista de Novas Mensagens"
                >
                  {this.state.accessibilityOption ? (
                    <ul id="accessibility-list" className="accessibility-item">
                      <li
                        id="accessibility-first-item-list"
                        className="accessibility-item"
                        tabIndex="6"
                      >
                        <h3>Para ler as mensagens, seta para baixo.</h3>
                      </li>
                      {this.handleAccessibilityList(
                        accessibilityNotReadMessagesList
                      )}
                      <li className="accessibility-item">
                        Fim da lista. Para acessar novamente as mensagens
                        acessar lista principal ou lista de contexto.
                      </li>
                    </ul>
                  ) : (
                    ''
                  )}
                </section>
                <QuickAccess
                  channel="fullscreen"
                  isQuickAccessOpen={this.state.isQuickAccessOpen}
                  quickAccess={this.state.quickAccess}
                  handleSendId={this.handleSendQuickAccessItemId}
                  handleCloseQuickAccess={this.handleQuickAccessClick}
                />
                {suggestionListOpen ? (
                  <SuggestionList
                    list={suggestions}
                    sendMessage={this.sendMessage}
                  />
                ) : (
                  ''
                )}
                <form
                  onSubmit={this.handleSubmit}
                  className="webchat-body-chat-footer"
                >
                  <input
                    tabIndex="1"
                    id="main-input-chat-field"
                    className={`webchat-input-quickaccess-${
                      this.state.isQuickAccessActive ? 'enable' : 'disable'
                    }`}
                    title={i18n.t('Campo Inserção de mensagem')}
                    placeholder={i18n.t('Digite sua mensagem')}
                    onChange={(e) => this.handleInputChange(e)}
                    onKeyDown={this.handleKeyDown}
                    value={message}
                    autoComplete="off"
                    maxLength={1000}
                  />
                  <button
                    type="submit"
                    className="webchat-body-chat-footer-img-send pointer"
                    tabIndex="2"
                  >
                    <img
                      src={require('../../assets/images/ic_send_message.svg')}
                      alt={i18n.t('Botão Enviar Mensagem')}
                      onClick={this.handleSubmit}
                    />
                  </button>
                  <label
                    tabIndex="3"
                    id="label-attach-file"
                    className="custom-file-upload"
                    style={{ cursor: 'pointer' }}
                    title={i18n.t('Campo Anexar Arquivo')}
                  >
                    <span className="accessibility-item">
                      Campo Anexar Arquivo
                    </span>
                    <input
                      type="file"
                      className="form-control-file"
                      id="profile_pic"
                      onChange={this.onSelectFile}
                      style={{ display: 'none' }}
                      title={i18n.t('Campo Anexar Arquivo')}
                    />
                    <img
                      src={require('../../assets/images/ic_attachment.svg')}
                      alt={i18n.t('Inserir Anexo')}
                    />
                  </label>
                  <label
                    id="quick-access-button"
                    className={`quick-access-icon ${
                      this.state.isQuickAccessOpen ? '' : 'disable'
                    }
                    ${this.state.isQuickAccessActive ? '' : 'deactivate'}`}
                    style={{ cursor: 'pointer' }}
                    onClick={this.handleQuickAccessClick}
                  >
                    <img
                      src={require('../../assets/images/duvidas_frequentes.svg')}
                      alt="Botão Lista de Acesso Rápido"
                    />
                  </label>
                </form>
              </div>
            </div>
          </div>
          <div className="code7-boteria-bot-widget-footer">
            <p className="code7-boteria-bot-widget-footer-text">
              <a href={poweredByUrl} target="_blank" rel="noopener noreferrer">
                {poweredBy}
              </a>
            </p>
          </div>
        </div>
        <ModalViewImages
          message={this.state.messageSelected}
          onClose={this.handleToggleModal}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  bot: state.bots.bot,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ ...BotsCreators }, dispatch);

export default withRouter(withTranslation()(Webchat));
